/**
 * DevExtreme (ui/data_grid/ui.data_grid.column_headers.js)
 * Version: 18.2.4
 * Build date: Mon Dec 17 2018
 *
 * Copyright (c) 2012 - 2018 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
"use strict";
var gridCore = require("./ui.data_grid.core"),
    columnHeadersViewModule = require("../grid_core/ui.grid_core.column_headers");
exports.ColumnHeadersView = columnHeadersViewModule.views.columnHeadersView;
gridCore.registerModule("columnHeaders", columnHeadersViewModule);



//////////////////
// WEBPACK FOOTER
// C:/projects/wct-nextias-ui/node_modules/devextreme/ui/data_grid/ui.data_grid.column_headers.js
// module id = ../../../../devextreme/ui/data_grid/ui.data_grid.column_headers.js
// module chunks = common